import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../constants';
import { Alert, Button, Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';

const CheckoutForm = ({ selectedPackage, userId, handleCancel }) => {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState(null);
    const rawUserData = localStorage.getItem('userData');
    const userData = rawUserData && rawUserData !== 'undefined' && rawUserData !== 'null'
        ? JSON.parse(rawUserData)
        : null;

    console.log(selectedPackage.id, 'jaw')
    console.log(userData, 'userData')

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        const result = await stripe.confirmSetup({
            elements,
            redirect: 'if_required'
        });

        if (result.error) {
            setErrMsg(result.error.message);

            console.log(result.error.message);
        } else {
            console.log('hassan')
            const token = userData.authToken;

            try {
                if (userData?.subscriptionPackage) {
                    const response = await axios.put(
                        `${BASE_URL}/subscription/update/${selectedPackage.id}`,
                        {}, // Empty body if not sending additional data
                        {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );
                    if (response.data.status) {
                        userData.subscriptionPackage = response.data.result
                        localStorage.setItem('userData', JSON.stringify(userData));
                        navigate('/account');
                    }
                    else {
                        console.log(response.data.message)
                        setErrMsg(response.data.message);
                    }
                }
                else {
                    const response = await axios.put(
                        `${BASE_URL}/subscription/update/${selectedPackage.id}`,
                        {}, // Empty body if not sending additional data
                        {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );
                    if (response.data.status) {
                        if (userData) {
                            userData.subscriptionPackage = response.data.result
                            localStorage.setItem('userData', JSON.stringify(userData));
                            navigate('/account');
                        }
                        else {
                            let newUserData = {}
                            console.log(newUserData, 'userData123')
                            newUserData.subscriptionPackage = response.data.result
                            localStorage.setItem('userData', JSON.stringify(newUserData));
                            navigate('/login');
                        }
                    }
                    else {
                        console.log(response.data.message)
                        setErrMsg(response.data.message);
                    }
                }

            }
            catch (error) {
                const errorMessage = error.response?.data?.message;
                console.log(error, 'errorMessage')
                setErrMsg(errorMessage);
            }

        }
    };

    return (
        <Container className="d-flex justify-content-center" style={{ minHeight: '80vh' }}>
            <Row className="align-items-center w-100">
                <Col md={{ size: 6, offset: 3 }}>
                    <Card className="p-4">
                        <CardBody>
                            {/* <CardTitle tag="h5" className="text-center mb-4">Complete Payment</CardTitle> */}

                            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}
                            <form onSubmit={handleSubmit}>
                                <PaymentElement />
                                <Button color="primary" disabled={!stripe}>Subscribe</Button>
                                <Button style={{ marginLeft: '10px' }} color="danger" onClick={handleCancel}>Cancel</Button>

                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CheckoutForm;
